// import { AppDispatch } from "../store";
// import { showSnackbar } from "../store/slices/snackbarSlice";

// export const handleSnackbar = (dataOrError: any) => {
//     return (dispatch: AppDispatch) => {
//         let message = "Something happened.";
//         let finalSeverity: "success" | "error" | "info" | "warning" = "info";

//         // If it's an Axios error, extract response data
//         const payload = dataOrError?.response?.data || dataOrError;

//         if (payload?.responseCode === "SUCCESS") {
//             // Success case
//             message = payload.responseMessage || "Operation successful.";
//             finalSeverity = "success";
//         } else if (payload?.errors?.length > 0) {
//             // Standardized error case
//             message =
//                 payload.errors[0]?.errorMessage ||
//                 payload.errors[0]?.errorCode ||
//                 "An error occurred.";
//             finalSeverity = "error";
//         } else if (dataOrError?.message) {
//             //Fallback for raw errors (like network errors)
//             message = dataOrError.message;
//             finalSeverity = "error";
//         }

//         dispatch(
//             showSnackbar({
//                 message,
//                 severity: finalSeverity,
//             })
//         );
//     };
// };


import { AppDispatch } from "../store";
import { showSnackbar } from "../store/slices/snackbarSlice";

export const handleSnackbar = (dataOrError: any) => {
    return (dispatch: AppDispatch) => {
        let message = "Something happened.";
        let finalSeverity: "success" | "error" | "info" | "warning" = "info";

        // Extract backend payload
        const payload = dataOrError?.response?.data || dataOrError;

        // SUCCESS case
        if (payload?.responseCode === "SUCCESS") {
            message = payload.responseMessage || "Operation successful.";
            finalSeverity = "success";
        }
        // NEW CASE → message is an ARRAY now
        else if (Array.isArray(payload?.message)) {
            const errors = payload.message.map(
                (m: { errorMessage?: string; errorCode?: string }) =>
                    m.errorMessage || "Unknown error"
            );

            message = errors.join("\n"); // Join multiple errors
            finalSeverity = "error";
        }
        // FALLBACK for generic errors
        else if (dataOrError?.message) {
            message = dataOrError.message;
            finalSeverity = "error";
        }

        dispatch(
            showSnackbar({
                message,
                severity: finalSeverity,
            })
        );
    };
};
